import { persisted } from 'svelte-local-storage-store';

const KEY = 'allibee/template-maker-tutorial:enabled';

export const templateTutorialEnabled = persisted(KEY, true);
